module.exports = __webpack_public_path__ + "static/media/info_icon.36767d4a.svg";